export default "__VITE_ASSET__BKedZAc9__"